import { makeAutoObservable, runInAction } from "mobx";
import * as api from "../api";

class AccountStore {
    _id = null;
    account = null;
    events = [];
    isLoading = true;
    allCoupons = {};
    fetchingCoupons = false;

    constructor(_id) {
        makeAutoObservable(this);
        this._id = _id;
    }

    get productionCoupons() {
        return Object.values(this.allCoupons).filter(coupon => !coupon.event);
    }

    getCoupon(couponId) {
        return this.allCoupons[couponId];
    }

    updateCoupon(coupon) {
        runInAction(() => {
            this.allCoupons[coupon._id] = coupon;
        });
    }

    async deleteCoupon(couponId) {
        await api.deleteCoupon({ accountId: this._id, couponId });
        runInAction(() => delete this.allCoupons[couponId]);
    }

    async fetchProductionCoupons() {
        try {
            this.fetchingCoupons = true;
            const { data } = await api.getCouponsByAccount({ accountId: this._id });
            data.forEach(c => this.allCoupons[c._id] = c);
        } catch (e) {
            console.error(e);
        } finally {
            runInAction(() => this.fetchingCoupons = false);
        }
    }

    async fetchData() {
        this.isLoading = true;
        const promises = [
            api.getAccountSecured(this._id),
            api.getAccountEvents(this._id),
            this.fetchProductionCoupons()
        ];
        const [account, events] = await Promise.all(promises);
        this.events = events.data.map(event => event._id);
        this.account = account.data;
        runInAction(() => this.isLoading = false);
    }

    async updateAccount(accountData) {
        try {
            const subAccountData = { ...accountData };
            const { data } = await api.updateAccount({ accountId: this._id, subAccountData });
            runInAction(() => {
                this.account = { ...this.account, ...data };
            });
            return data;
        } catch (error) {
            console.error('Error updating account:', error);
            throw error;
        }
    }
}

export default AccountStore;